export const POPUP_V2_STORAGE_PREFIX = "fpep-popup-v2-dismissed";

const getStorageKey = (campaign = {}) => {
  const id = Number(campaign?.id);
  const revision = Number(campaign?.revision);
  if (!Number.isInteger(id) || id <= 0 || !Number.isInteger(revision) || revision <= 0) {
    return null;
  }
  return `${POPUP_V2_STORAGE_PREFIX}:${id}:r${revision}`;
};

export const getPopupV2CampaignKey = (campaign = {}) => getStorageKey(campaign);

const safeGet = (storage, key) => {
  if (!storage || !key) return false;
  try {
    return storage.getItem(key) === "1";
  } catch (_error) {
    return false;
  }
};

const safeSet = (storage, key) => {
  if (!storage || !key) return false;
  try {
    storage.setItem(key, "1");
    return true;
  } catch (_error) {
    return false;
  }
};

export const getPopupV2DismissStorage = (campaign, windowObject = window) => {
  const policy = campaign?.behavior?.dismissPolicy;
  try {
    return policy === "session" ? windowObject.sessionStorage : windowObject.localStorage;
  } catch (_error) {
    return null;
  }
};

export const isPopupV2Dismissed = (campaign, windowObject = window) => {
  const key = getStorageKey(campaign);
  return safeGet(getPopupV2DismissStorage(campaign, windowObject), key);
};

export const dismissPopupV2Campaign = (campaign, windowObject = window) => {
  const key = getStorageKey(campaign);
  return safeSet(getPopupV2DismissStorage(campaign, windowObject), key);
};
